import { FC, ReactNode } from "react";

import { TenantClientSelector } from "./TenantClientSelector";
import { useTenantClientSelector } from "./useTenantClientSelector";

import { Popover, PopoverTrigger } from "@/components/ui/v2/popover";
import { useTenants } from "@/lib/hooks/useTenants";

type TenantClientSelectorTriggerProps = {
  trigger: ReactNode;
  addTenant: ReturnType<typeof useTenants>["addTenant"];
  tenantId: string;
  setTenantId: (id: string) => void;
};

export const TenantClientSelectorTrigger: FC<
  TenantClientSelectorTriggerProps
> = ({ trigger, addTenant, tenantId, setTenantId }) => {
  const { open, setOpen } = useTenantClientSelector();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <TenantClientSelector
        open={open}
        onOpenChange={setOpen}
        addTenant={addTenant}
        tenantId={tenantId}
        setTenantId={setTenantId}
      />
    </Popover>
  );
};
